/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Map as ImmutableMap } from 'immutable';
import { updateTemplateType } from '../../../actions/TemplateSettingsBufferActions';
import { TEMPLATE_TYPES, TEMPLATE_TYPE } from 'knowledge-content-ui/constants/ChooseTemplateConstants';
import { SCREENS } from '../../../constants/TrackingConstants';
import UsageTracker from '../../../utils/UsageTracker';
import ChangeTemplatePage from './ChangeTemplatePage';
import ConfirmChangeTemplateModal from './ConfirmChangeTemplateModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const templateTypeToTrackingSuffix = {
  [TEMPLATE_TYPE.CARDS]: 'cards',
  [TEMPLATE_TYPE.CONTENT]: 'content-rich',
  [TEMPLATE_TYPE.DEFAULT]: 'classic',
  [TEMPLATE_TYPE.MINIMAL]: 'minimal',
  [TEMPLATE_TYPE.TILES]: 'tiles'
};
class ChangeTemplate extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      showConfirmChangeTemplateModal: false,
      showLoadingOverlay: false,
      templateTypeToUpdate: undefined
    };
    this.handleChooseTemplateClick = templateType => {
      UsageTracker.track('templateEditorInteraction', {
        screen: SCREENS.TEMPLATE_EDITOR,
        action: `template-choose-${templateTypeToTrackingSuffix[templateType]}`
      });
      this.setState({
        showConfirmChangeTemplateModal: true,
        templateTypeToUpdate: templateType
      });
    };
    this.handleTemplateChangeConfirm = () => {
      const {
        knowledgeBaseId,
        onClose,
        templateSettings
      } = this.props;
      const {
        templateTypeToUpdate
      } = this.state;
      this.setState({
        showConfirmChangeTemplateModal: false,
        showLoadingOverlay: true
      });
      this.props.updateTemplateType(knowledgeBaseId, templateSettings, templateTypeToUpdate, true).then(() => {
        onClose();
      });
    };
    this.handleTemplateChangeReject = () => {
      this.setState({
        showConfirmChangeTemplateModal: false,
        templateTypeToUpdate: undefined
      });
    };
  }
  renderContent() {
    const {
      currentTemplate,
      onClose
    } = this.props;
    const {
      showLoadingOverlay
    } = this.state;
    return /*#__PURE__*/_jsx(ChangeTemplatePage, {
      currentTemplate: currentTemplate,
      onBackClick: onClose,
      onChooseTemplateClick: this.handleChooseTemplateClick,
      showLoadingOverlay: showLoadingOverlay
    });
  }
  render() {
    const {
      showConfirmChangeTemplateModal
    } = this.state;
    return /*#__PURE__*/_jsxs("div", {
      children: [this.renderContent(), showConfirmChangeTemplateModal && /*#__PURE__*/_jsx(ConfirmChangeTemplateModal, {
        onConfirm: this.handleTemplateChangeConfirm,
        onReject: this.handleTemplateChangeReject
      })]
    });
  }
}
ChangeTemplate.propTypes = {
  currentTemplate: PropTypes.oneOf(TEMPLATE_TYPES).isRequired,
  knowledgeBaseId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof Map' is not assignable to... Remove this comment to see the full error message
  templateSettings: PropTypes.instanceOf(ImmutableMap).isRequired,
  updateTemplateType: PropTypes.func.isRequired
};
const mapStateToProps = state => {
  const {
    knowledgeBaseDetails: {
      knowledgeBase: {
        id: knowledgeBaseId
      }
    },
    templateSettings
  } = state;
  return {
    knowledgeBaseId,
    templateSettings
  };
};
const mapDispatchToProps = {
  updateTemplateType
};
export default connect(mapStateToProps, mapDispatchToProps)(ChangeTemplate);